import { IS_DEVELOPING } from "./config";

/**
 * Master development flag + gated console logger.
 * Use `devLog(...)` in place of `console.log(...)` for any informational/timing
 * log so the whole app's dev logging can be toggled from here.
 */

export function devLog(...args: unknown[]): void {
  if (IS_DEVELOPING) {
    console.log(...args);
  }
}
